var n = 9007199254740991;
function r(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= n;
}
export {
  r as default
};
